import { Modal, Container } from "react-bootstrap";
import { Row, Col, Button } from "antd";
import React from "react";

function EditModal(props) {
  return (
    <div>
      <Modal show={props.show} onHide={props.onHide} size={props.size} centered>
        <Modal.Header />
        <Modal.Body>
          <div className="col-sm-12">
            <text className="custom-modal-body-title">
              {" "}
              EDIT {props.title}{" "}
            </text>
            <Container fluid className="modal-cont justify-content-center">
              {props.children}
            </Container>

            <Row className="mt-4 d-flex justify-content-end">
              <Col xs={12}>
              <Row className=" w-100">
                <Col xs={12}>
                  <Button
                    className="button-secondary me-3 w-100"
                    onClick={props.onHide}
                  >
                    Cancel
                  </Button>
                </Col>
                <Col xs={12}>
                    <Button
                      type="primary"
                      className="button-primary w-100"
                      onClick={props.onSave}
                    >
                      Save
                    </Button>
                </Col>
              </Row>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

EditModal.defaultProps = {
  title: "",
  // type:"",
  size: "xl",
  show: () => {},
  onHide: () => {},
  onSave: () => {},
};

export default EditModal;
